import { render, staticRenderFns } from "./ruta-aventureros.vue?vue&type=template&id=f4d896bc&"
import script from "./ruta-aventureros.vue?vue&type=script&lang=js&"
export * from "./ruta-aventureros.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports